var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirtualSim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 159,
    viewBox: "0 0 160 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16559_50102)",
    filter: "url(#filter0_i_16559_50102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0002 158.296C123.712 158.296 159.148 122.86 159.148 79.148C159.148 35.4359 123.712 0 80.0002 0C36.2882 0 0.852539 35.4359 0.852539 79.148C0.852539 122.86 36.2882 158.296 80.0002 158.296Z",
    fill: "url(#paint0_linear_16559_50102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5158 157.375C92.1598 157.307 92.8029 157.231 93.445 157.148C96.0464 156.696 98.6236 156.115 101.167 155.406C103.71 154.701 106.216 153.869 108.676 152.913C111.136 151.959 113.546 150.883 115.898 149.688C118.251 148.489 120.543 147.173 122.764 145.745C124.983 144.32 127.129 142.785 129.195 141.145C131.261 139.507 133.244 137.767 135.136 135.931C137.032 134.09 138.835 132.155 140.538 130.134C142.236 128.117 143.833 126.017 145.321 123.841C146.812 121.661 148.192 119.407 149.457 117.089C150.721 114.773 151.868 112.396 152.895 109.966C153.925 107.538 154.833 105.059 155.616 102.541C155.735 102.087 155.85 101.631 155.962 101.175L95.1269 40.3454C94.8957 40.1016 94.6173 39.9074 94.3085 39.7747C93.9998 39.642 93.6673 39.5736 93.3312 39.5737H52.862C52.2061 39.5737 51.5769 39.8343 51.1131 40.2982C50.6493 40.762 50.3887 41.3911 50.3887 42.0471V116.248C50.3887 116.904 50.6493 117.533 51.1131 117.997C51.5769 118.461 52.2061 118.721 52.862 118.721L91.5158 157.375Z",
    fill: "#04177F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8572 39.5737C52.2012 39.5737 51.5721 39.8343 51.1082 40.2982C50.6444 40.762 50.3838 41.3911 50.3838 42.0471V116.248C50.3838 116.904 50.6444 117.533 51.1082 117.997C51.5721 118.461 52.2012 118.721 52.8572 118.721H112.218C112.874 118.721 113.503 118.461 113.967 117.997C114.431 117.533 114.691 116.904 114.691 116.248V62.0171C114.691 61.384 114.449 60.775 114.014 60.3154L95.127 40.3454C94.8958 40.1016 94.6173 39.9074 94.3086 39.7747C93.9999 39.642 93.6673 39.5736 93.3313 39.5737H52.8572ZM55.3305 44.5205H92.2678L109.745 63.0015V113.775H55.3305V44.5205ZM62.7506 74.2009C62.0946 74.2009 61.4655 74.4614 61.0017 74.9253C60.5378 75.3891 60.2773 76.0182 60.2773 76.6742V106.355C60.2773 107.011 60.5378 107.64 61.0017 108.104C61.4655 108.567 62.0946 108.828 62.7506 108.828H102.324C102.98 108.828 103.61 108.567 104.073 108.104C104.537 107.64 104.798 107.011 104.798 106.355V76.6742C104.798 76.0182 104.537 75.3891 104.073 74.9253C103.61 74.4614 102.98 74.2009 102.324 74.2009H62.7506ZM65.224 79.1476H70.1707V89.041H95.0033V79.1476H99.8511V103.881H95.0033V93.9878H70.1707V103.881H65.224V79.1476ZM75.1174 79.1476H80.0642V84.0943H75.1174V79.1476ZM85.0109 79.1476H90.0566V84.0943H85.0109V79.1476ZM75.1174 98.9345H80.0642V103.881H75.1174V98.9345ZM85.0109 98.9345H90.0566V103.881H85.0109V98.9345Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_16559_50102",
    x: 0.852539,
    y: 0,
    width: 158.296,
    height: 167.076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.89346
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.39022
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16559_50102"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16559_50102",
    x1: 80.0002,
    y1: 0,
    x2: 80.0002,
    y2: 158.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D5EF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D9FE7",
    stopOpacity: 0.82
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16559_50102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158.295,
    height: 158.295,
    fill: "white",
    transform: "translate(0.852539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualSim);
export default __webpack_public_path__ + "static/media/VirtualSim.c07b332c236a0ceeffd3064dd5dbf05c.svg";
export { ForwardRef as ReactComponent };